import { IModal } from 'customTypes';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import TuiGrid from '../Table/TuiGrid';
import { BtnBlue, BtnGray } from '../Button';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBackground } from '../../assets/styles/Modal';
import i18n from '../../translation/i18n';
import { toast } from 'react-toastify';
import { PulseLoader } from 'react-spinners';
import ProgressModal from './ProgressModal';
import Portal from '../Portal';
import TextInfoBox from '../TextInfoBox';

interface IProps {
  setOpenModal: Dispatch<SetStateAction<IModal>>;
  title: string;
  tableState?: any;
  copySetting: any;
  loading?: boolean;
  rowState: any;
  copyState: any;
}

const BsSettingCopyModal = ({ setOpenModal, title, tableState, copySetting, loading, rowState, copyState }: IProps) => {
  const { t } = useTranslation();
  const [checkList, setCheckList] = useState([]);
  const [modalColumns, setModalColumns] = useState<any[]>([]);
  const [openSubModal, setOpenSubModal] = useState<any>({ status: false, type: '', data: '', index: 0 });
  useEffect(() => {
    setModalColumns([
      {
        header: t('방송 장비 명'),
        name: 'bsName',
        sortable: true,
        renderer: { classNames: ['text_secondary'] },
      },
    ]);
  }, [tableState, i18n.language]);

  useEffect(() => {
    if (loading) {
      setOpenSubModal((prev: any) => ({ ...prev, status: true, type: 'progress' }));
    }
  }, [loading]);

  const onClickModalCheck = (bsList: any) => {
    const newBsList = bsList.map((bs: any) => {
      return {
        id: bs.bsId,
        pwd: bs.bsPwd,
        ip: bs.bsIp,
        port: bs.pPort,
        bsName: bs.bsName,
      };
    });
    setCheckList(newBsList);
  };

  const onClickClose = () => {
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
  };

  const onClickCopy = async () => {
    if (checkList.length === 0) {
      toast.warn(t('방송 장비를 선택해주세요'));
    } else {
      await copySetting(checkList);
      // onClickClose();
    }
  };

  return (
    <ModalBackground role='presentation'>
      <Modal minWidth={30}>
        <div
          className='modal height-fit'
          // style={{ height: 'auto', padding: '0 0.5rem' }}
          role='presentation'
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <div className='inputForm-head'>
            <div className='modalHeaderTitle'>{title}</div>
            <div className='closeBtn' onClick={onClickClose} role='presentation'>
              <span className='material-symbols-rounded'>close</span>
            </div>
          </div>
          <TextInfoBox ico='language' description={`원본 방송 장비명 : ${rowState.bsName}`} color='orange' />
          <div className='sensor flexColumn flex-between col-w100'>
            {loading ? (
              <div className='centered-content h600'>
                <PulseLoader color='rgb(0, 122, 255)' size='10px' />
              </div>
            ) : (
              <div>
                <TuiGrid data={tableState} columns={modalColumns} onClickCheckBox={onClickModalCheck} rowClickCheckBox />
              </div>
            )}

            <div className='modal-footer flex-end col-w100'>
              <BtnBlue onClick={onClickCopy} disabled={loading}>
                {t('복사')}
              </BtnBlue>
            </div>
          </div>
        </div>
      </Modal>
      <Portal openModal={openSubModal?.status}>
        {openSubModal.type === 'progress' && <ProgressModal openModal={openSubModal} setOpenModal={setOpenSubModal} copyState={copyState} loading={loading} />}
      </Portal>
    </ModalBackground>
  );
};

export default BsSettingCopyModal;
